/**
 * This function generates fallback text for avatars based on the input string.
 * Array.from is necessary here to handle cases where the input might contain emojis or special characters.
 * It ensures that we correctly extract characters from the string, especially for multi-byte characters like emojis
 */
export const generateFallbackText = (text: string): string => {
    const trimmedText = text.trim();
    if (!trimmedText) return "";

    const words = trimmedText.split(/\s+/);

    // Get the first character from the first and last word that have content
    if (words.length > 1) {
        const firstWord = words[0];
        const lastWord = words[words.length - 1];

        const initials = [firstWord, lastWord]
            .map((word) => Array.from(word.trim())[0])
            .filter(Boolean)
            .join("");

        return initials.toUpperCase();
    }

    // For single word or no spaces, take first 2 characters
    const firstTwoChars = Array.from(trimmedText).slice(0, 2).join("");
    return firstTwoChars.toUpperCase();
};
